export default __webpack_public_path__ + "static/media/Avatar4.23459628.mp3";